import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const messageService = inject(MessageService);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 400) {
        if (err.error.errors) {
          const modelStateErrors = [];
          for (const key in err.error.errors) {
            if (err.error.errors[key]) {
              modelStateErrors.push(err.error.errors[key]);
            }
          }
          messageService.add({
            severity: 'warn',
            summary: 'Validation Error',
            detail: `${modelStateErrors.join(', ')} validation error(s) occurred.`
          });
          throw modelStateErrors.flat();
        } else {
          messageService.add({
            severity: 'warn',
            summary: 'Warning',
            detail: err.error.message
          });
        }
      }
      if (err.status === 401) {
        messageService.add({
          severity: 'error',
          summary: 'Unauthorized',
          detail: err.error.title || 'You are not authorized to access this resource.'
        });
        // clear the token and redirect to login page
        authService.logout();
        router.navigate(['/auth/login'], {
          queryParams: { returnUrl: router.routerState.snapshot.url }
        });
      }
      if (err.status === 403) {
        console.log('Forbidden');
      }
      if (err.status === 404) {
        messageService.add({
          severity: 'error',
          summary: '404 Not Found',
          detail: 'The requested resource was not found.'
        });
      }
      if (err.status === 500) {
        const navigationExtras: NavigationExtras = {
          state: { error: err.error }
        };
      }
      return throwError(() => err);
    })
  );
};
